import OpcaoSelecao from '@/components/base/OpcaoSelecao';

interface CartaoQuemVaiProps {
  valor: 'eu' | 'outra' | null;
  onChange: (v: 'eu' | 'outra') => void;
}

export default function CartaoQuemVai({ valor, onChange }: CartaoQuemVaiProps) {
  return (
    <div className="rounded-lg border border-secondary-200 bg-white p-6">
      <h2 className="text-base font-medium text-foreground-950">Quem vai participar?</h2>
      <p className="mt-1 text-sm text-secondary-500">
        Você pode se inscrever ou inscrever outra pessoa. Se for para o seu pai, sua mãe ou seu
        filho, escolha a segunda opção — eles não precisam ter conta no site.
      </p>
      <div className="mt-3 space-y-1">
        <OpcaoSelecao tipo="radio" checked={valor === 'eu'} onChange={() => onChange('eu')}>
          Eu mesmo
        </OpcaoSelecao>
        <OpcaoSelecao tipo="radio" checked={valor === 'outra'} onChange={() => onChange('outra')}>
          Outra pessoa
        </OpcaoSelecao>
      </div>
    </div>
  );
}